import React, { FC, memo } from 'react';
import FormikInput from '@minecraft.formik-input';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';

type Props = FilterData;

const Profession: FC<Props> = ({ name, label }) => {
  return (
    <>
      <Label>{label}</Label>
      <FormikInput name={name} maxLength={50} size="small" />
    </>
  );
};

export default memo(Profession);
